module.exports = __webpack_public_path__ + "media/theme/tutorial__mobage--1--create-10c9588e.png";